import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Typography, Link } from "@common-ui/ui";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";

export const BreadcrumbsComponent = ({ items }) => {
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {items?.map((item, index) => {
        return index === items?.length - 1 ? (
          <Typography fontWeight="700" sx={{ color: "#333333" }} key={index}>
            {item.label}
          </Typography>
        ) : (
          <Link
            component={RouterLink}
            key={index}
            color="inherit"
            fontWeight="400"
            to={item.link}
            // style={{ textDecoration: "none" }}
            underline="hover"
          >
            <Typography color="textPrimary">{item.label}</Typography>
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};
